import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Theme {
    status: {
      success: object;
      warning: object;
    };
    customColor: {
      secondary: object;
    };
  }
  interface ThemeOptions {
    status?: {
      success?: object;
      warning?: object;
    };
    customColor: {
      secondary: object;
    };
  }
}
const theme = createTheme({
  status: {
    success: {
      color: "rgba(84, 214, 44, 0.16)",
      textContrast: "rgb(34, 154, 22)",
    },
    warning: {
      color: "rgba(255, 193, 7, 0.16)",
      textContrast: "rgb(183, 129, 3)",
    },
  },
  customColor: {
    secondary: {
      color: "rgba(0, 0, 0, 0.53)",
    },
  },
  palette: {
    primary: {
      light: "#52B46A",
      main: "#52B46A",
      dark: "#52B46A",
    },
    secondary: {
      light: " #454545",
      main: "#000000 ",
      dark: "#000000",
      contrastText: "white",
    },
    success: {
      main: "rgb(34, 154, 22)",
      light: "rgba(84, 214, 44, 0.16)",
      dark: "#1b5e20",
    },
    warning: {
      main: "rgb(183, 129, 3)",
      light: "rgba(255, 193, 7, 0.16)",
      dark: "#e65100",
    },
    error: {
      main: "#FECC4C",
      light: "#fffadd",
      dark: "#e7c400",
    },
    info: {
      main: "rgb(2, 136, 209)",
      light: "rgb(2, 136, 209, 0.16)",
      dark: "#01579b",
    },
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
  },
});

export default theme;
